// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3hAtm","title":"Info_title__3TqZQ","selects":"Info_selects__2Yibh","requiredAsterisk":"Info_requiredAsterisk__sj5jE"};